module.exports = __webpack_public_path__ + "img/tws2.bcaaa763.png";